import { Message } from '@/types/discover';
import { cn } from '@/utils/tailwind';

interface Props {
  data: Message;
  isDashboard: boolean;
  isAlert?: boolean;
}

const UserBubble = ({ data, isAlert }: Props) => {
  return (
    <div
      className={cn(
        'max-w-[550px] whitespace-pre-wrap break-words rounded-[12px] bg-point-150 p-[12px] text-gr-900 Body5M14',
        { 'bg-white text-center text-gr-600 Caption1M12': isAlert },
      )}
    >
      {data.text}
    </div>
  );
};

export default UserBubble;
